import crud from '@/crud/index/index'
import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  methods,
  mounted,
  mixins: [crud],

  /* route API for professional documents */
  resourcePath: '/v1/professional/documents/?limit=30&page=1&pagination=true'
}



// WEBPACK FOOTER //
// ./src/app/professional/documents/form/resources/index.js